type Strings =
    string | string[]

function addString(into: Strings | null, toAdd: Strings | null): Strings
{
    if (toAdd === null) {
        return into;
    } else if (into === null) {
        return toAdd;
    } else if (Array.isArray(into)) {
        if (Array.isArray(toAdd)) {
            return into.concat(toAdd);
        } else {
            into.push(toAdd);
            return into;
        }
    } else {
        if (Array.isArray(toAdd)) {
            return [into].concat(toAdd);
        } else {
            return [into, toAdd];
        }
    }
}

function toSingleString(strings: Strings | null): string
{
    if (strings == null) {
        return null;
    } else {
        return (Array.isArray(strings)) ?
            strings.join("\n") :
            strings as string;
    }
}

export
{
    addString,
    toSingleString,
    Strings,
}